var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mt-5 mx-auto",staticStyle:{"max-width":"20rem"}},[_c('ParentalControls')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }